import DashboardWrapper from "components/new-stuff/ui/DashboardWrapper"
import { useState } from "react"
import { Input, Spin, Tooltip } from "antd"

import { useGet } from "utils/useFetch"
import { useLocation, useNavigate } from "react-router-dom"
import {
  ICurrencyInfo,
  ICurrencyInfoRes,
} from "../crossborder/interface/payouts"
import ViewGlobal from "../crossborder/ViewGlobal"
import { Button, Label, P2 } from "components"
import CustomModal from "components/new-stuff/ui/modals/CustomModal"
import { useAppNotificationStore } from "stores"
import { useMutation, useQuery } from "@tanstack/react-query"
import { ExclamationCircleIcon } from "@heroicons/react/24/outline"
import { ICustomScheduleApprovers } from "./interface"
import {
  PAYMENT_SCHEDULES_ENDPOINTS,
  paymentSchedulesService,
} from "services/paymentSchedulesService"
import { onQueryError } from "utils/utils"
import { IPreviewCustomScheduleState } from "pages/dashboard/people/requests/all/exits/typing"

const PreviewCustomSchedule = () => {
  const navigate = useNavigate()
  const myParam = useLocation().search
  const { toast } = useAppNotificationStore()
  const x = new URLSearchParams(myParam).get("x")
  const location = useLocation()
  const isApproval = location.pathname.includes("/approval")
  const { description, status, statusId, date, payment_schedule_id } =
    (location.state as IPreviewCustomScheduleState) || {}

  const [showViewModal, setShowViewModal] = useState(false)
  const [showApprovers, setShowApprovers] = useState(false)
  const [reviewType, setReviewType] = useState("")
  const [modalData, setModalData] =
    useState<IPreviewCustomScheduleState | null>(null)
  const [reason, setReason] = useState("")
  const [activeCurrency, setActiveCurrency] = useState<ICurrencyInfo | null>(
    null
  )

  const { isLoading: isCurrenciesLoading, data: currenciesData } =
    useQuery<ICurrencyInfoRes>({
      queryFn: () =>
        isApproval
          ? paymentSchedulesService.viewCurrenciesApproval(x)
          : paymentSchedulesService.viewCurrencies(x),
      queryKey: [
        isApproval
          ? `${PAYMENT_SCHEDULES_ENDPOINTS.VIEW_CURRENCIES_APPROVAL}`
          : `${PAYMENT_SCHEDULES_ENDPOINTS.VIEW_CURRENCIES}`,
        x,
      ],
      onSuccess: (data: any) => {
        {
          data?.data?.length > 1
            ? setActiveCurrency({
                currency_code: "Global",
                currency_symbol: "$",
                total: 0,
                count: 0,
              })
            : setActiveCurrency({
                currency_code: data?.data[0]?.currency_code,
                currency_symbol: data?.data[0]?.currency_symbol,
                total: data?.data[0]?.total,
                count: data?.data[0]?.count,
              })
        }
      },
    })
  const { isLoading: isLoadingNotes, data: approversData } = useQuery<
    IBaseRes<ICustomScheduleApprovers>
  >({
    queryFn: () =>
      isApproval
        ? paymentSchedulesService.viewScheduleDetailsApproval(x)
        : paymentSchedulesService.viewScheduleDetails(x),
    queryKey: [
      isApproval
        ? `${PAYMENT_SCHEDULES_ENDPOINTS.VIEW_SCHEDULE_DETAILS_APPROVAL}`
        : `${PAYMENT_SCHEDULES_ENDPOINTS.VIEW_SCHEDULE_DETAILS}`,
      x,
    ],
  })

  function handleDeclineAndApprove(type: "approve" | "decline") {
    // mixPanelEvent(`req-leaves-request-${type}-init`)
    declineOrApprove({
      id: Number(modalData?.payment_schedule_id),
      reason,
      type,
    })
  }
  const { isLoading: isApprovingOrDeclininng, mutate: declineOrApprove } =
    useMutation({
      mutationFn: async ({
        id,
        reason,
        type,
      }: {
        id: number
        reason: string
        type: "decline" | "approve"
      }) => {
        const endpoint = isApproval
          ? paymentSchedulesService.reviewPaymentScheduleApproval
          : paymentSchedulesService.reviewPaymentSchedule
        const data = await endpoint(id, type, reason)

        return data
      },
      onSuccess: (data, { type }) => {
        navigate(-1)
        data?.message && toast.success(data.message)
      },
      onError: onQueryError,
    })

  return (
    <DashboardWrapper>
      <div>
        <h6 className="text-sm text-padeBlack font-circular mb-3">
          Payment for {description}
        </h6>

        <div className="mb-20">
          <ViewGlobal
            currencies={currenciesData}
            activeCurrency={activeCurrency}
          />
        </div>
        {/* FOOTER */}
        <div className="fixed bottom-0 flex justify-end left-0 right-0 h-[64px] gap-4  py-3 px-20 bg-white ">
          {approversData && approversData?.data?.reviews?.length > 0 && (
            <Button
              color="secondary"
              disabled={isLoadingNotes}
              onClick={() => {
                setShowApprovers(true)
              }}
            >
              View Approvals
            </Button>
          )}
          <Button
            color="primary"
            onClick={() => {
              setModalData({
                status,
                statusId,
                date,
                description,
                payment_schedule_id,
              })
              setShowViewModal(true)
            }}
          >
            Review
          </Button>
        </div>
        <CustomModal
          destroyOnClose
          open={showViewModal}
          onCancel={() => {
            setShowViewModal(false)
            setModalData(null)
          }}
          title={
            <>
              {modalData?.status === "New"
                ? "Pending"
                : modalData?.status === "Approved"
                ? "Approved"
                : "Declined"}{" "}
              Payment Schedule
            </>
          }
          footer={
            <div className="w-full justify-end flex">
              {modalData?.statusId === 3 ? (
                <>
                  <Button
                    color="destructive"
                    className="mr-3"
                    disabled={reason === "" || isApprovingOrDeclininng}
                    submitting={isApprovingOrDeclininng}
                    onClick={() => {
                      setReviewType("decline")
                      handleDeclineAndApprove("decline")
                    }}
                  >
                    Decline
                  </Button>
                  {/* ======== Approve Btn ======== */}
                  {/* ======== Approve Btn ======== */}
                  <Button
                    color="primary"
                    className=""
                    disabled={isApprovingOrDeclininng}
                    onClick={() => {
                      setReviewType("approve")
                      handleDeclineAndApprove("approve")
                    }}
                    submitting={
                      isApprovingOrDeclininng && reviewType === "approve"
                    }
                  >
                    Approve
                  </Button>
                </>
              ) : (
                <Button
                  color="neutral"
                  className=""
                  onClick={() => {
                    setShowViewModal(false)
                    setModalData(null)
                  }}
                >
                  Close
                </Button>
              )}
            </div>
          }
        >
          <div className="flex flex-col items-center justify-center w-full h-full gap-2 ">
            <div className="!px-0 w-full">
              <div className="mb-4 space-y-1 ">
                <P2 className=" font-semibold text-neutral500 ">Date</P2>
                <P2 className="font-normal text-neutral400">
                  {modalData?.date}
                </P2>
              </div>

              <div className="mb-4 space-y-1 ">
                <P2 className=" font-semibold  text-neutral500">Description</P2>
                <P2 className="font-normal text-neutral400">
                  {modalData?.description}
                </P2>
              </div>

              {/* ======================= */}
              {/* ======= Note ========= */}
              {modalData?.statusId === 3 && (
                <div className="w-full mb-4">
                  <Tooltip
                    title={`Leave a note, this can be helpful if you're not the final approver.`}
                  >
                    <div className="flex gap-2 w-fit">
                      <Label
                        htmlFor="note"
                        className="font-avenir text-neutral500 font-semibold"
                      >
                        Note{" "}
                      </Label>

                      <ExclamationCircleIcon className="w-5 h-5 opacity-60 hover:opacity-100" />
                    </div>
                  </Tooltip>
                  <div className="my-1" />
                  <Input.TextArea
                    className="min-h-[82px]"
                    id="mobile-number"
                    required={false}
                    placeholder="Provide reason if declining"
                    value={reason}
                    onChange={(e) => {
                      setReason(e.target.value)
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </CustomModal>
        <CustomModal
          destroyOnClose
          open={showApprovers}
          onCancel={() => {
            setShowApprovers(false)
          }}
          title="Approval Workflow Reviews"
        >
          <div className="flex flex-col items-center justify-start w-full  gap-2 min-h-[250px] max-h-[362px] overflow-y-auto">
            {approversData?.data?.reviews?.map((item, index) => (
              <div
                key={index}
                className="border py-[21px] px-[18px] border-[#C2C7D0] rounded w-full flex items-center justify-start"
              >
                <p className=" font-circular font-medium">
                  {item?.description}
                </p>
              </div>
            ))}
          </div>
        </CustomModal>
      </div>
    </DashboardWrapper>
  )
}

export default PreviewCustomSchedule
